import styled from "styled-components";

export const Announcement = styled.div`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: ${({ theme, count }) =>
      count <= 4 ? `calc(50% - ${theme.space.md})` : `calc(33.3% - ${theme.space.md})`};
  }
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.space.md};
  }
`;
